const progressUpdateGoals = (goals, actuals) => {
  for (const goal in goals) {
    goals[goal] = {
      ...goals[goal],
      startingAllocation:
        Math.floor(actuals[goal]) || goals[goal].startingAllocation,
    }
  }
  return goals
}

export default progressUpdateGoals



// WEBPACK FOOTER //
// ./src/utils/progressUpdateGoals.js